import { MenuOption_model } from "@optisewer/library";
import { IGestSelectOption } from "@shared/library";
import { MenuArea_model } from "../models/ui_data/MenuArea_model";

// areaID/areaActive: id e stato attivo dell'area a cui appartiene questa option (l'area BE se
// assegnata, altrimenti l'option stessa fa da area a sé - vedi buildMenuFromOptions). areaActive
// viene propagato sull'enabled dell'option: un'area disattivata oscura così tutte le sue option
// tramite lo stesso meccanismo già usato da Sidebar (area.subs.every(s => !s.enabled)).
export const buildMenuOption = (option: IGestSelectOption<MenuOption_model>, areaID: number, areaActive: boolean): MenuOption_model => {
    const data = option.data;
    // fallback esplicito su entrambe le fonti (BE valorizza sia option.label che data.label con lo
    // stesso valore, ma non affidarsi a un solo lato): mai undefined, altrimenti react non renderizza
    // nulla al posto della label (lang[undefined] ?? undefined -> undefined -> <h5></h5> vuoto)
    const label = (data?.label ?? option.label ?? '') as string;
    const icon = (data?.icon ?? '') as string;
    const rawPath = data?.path;
    const path = rawPath
        ? (rawPath.startsWith('/') ? rawPath : `/${rawPath}`)
        : '/';

    return {
        id: Number(option.value),
        label,
        icon,
        color: data?.color,
        custom: data?.custom,
        enabled: !option.disabled && (data?.active ?? true) && areaActive,
        areaID,
        path,
    };
};

/**
 * Group by area if provided
 */
export const buildMenuFromOptions = (options: IGestSelectOption<MenuOption_model>[]): MenuArea_model[] => {
    const menu: MenuArea_model[] = [];
    const areasByID = new Map<number, MenuArea_model>();

    options.forEach(option => {
        const area = option.data?.area;
        const sub = buildMenuOption(option, area?.id ?? option.value as number, area?.active ?? true);

        if (!area) {
            menu.push({ ...sub, subs: [sub], hasArea: false });
            return;
        }

        let menuArea = areasByID.get(area.id);

        if (!menuArea) {
            // fallback su icona/colore della prima option quando l'area non li imposta; la label
            // dell'area (mai vuota lato BE, a differenza di icon/color) resta quella propria
            menuArea = { ...area, icon: area.icon || sub.icon, color: area.color ?? sub.color, subs: [], hasArea: true };
            areasByID.set(area.id, menuArea);
            menu.push(menuArea);
        }

        menuArea.subs.push(sub);
    });

    return menu;
};

// primo segmento del path (es. "/quality/dashboard" -> "quality", "/" -> ""), usato da
// Content per risalire al modulo/componente da montare per ogni option di menu
export const firstPathSegment = (path: string): string => path.replace(/^\//, '').split('/')[0];
